import React from 'react';

const OrgasmSolid = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M21 12.9874C20.9466 11.7698 20.5342 10.5874 19.88 9.5578C19.76 9.32849 19.62 9.09919 19.5 8.83998C19.1433 8.1776 19.0437 7.4075 19.22 6.67655C19.47 5.40043 18.85 4.99167 18.28 4.87203C16.97 4.59288 14.83 6.37746 14.81 6.3974C14.5849 6.59093 14.3712 6.79732 14.17 7.01552C14.0628 6.78236 13.9952 6.53303 13.97 6.27776C13.9233 5.50378 14.0675 4.73017 14.39 4.02461C14.5002 3.76799 14.5324 3.48476 14.4826 3.21006C14.4329 2.93535 14.3033 2.68126 14.11 2.4793C13.9078 2.26656 13.6488 2.11596 13.3635 2.0453C13.0782 1.97463 12.7786 1.98685 12.5 2.08051C11.2736 2.4316 10.1415 3.05158 9.18642 3.89509C8.23134 4.7386 7.47749 5.7843 6.98 6.9557C6.61037 7.90895 6.43036 8.9248 6.45 9.94662L6.25 9.58771C6.11589 9.34511 5.91424 9.14638 5.66938 9.01547C5.42452 8.88457 5.1469 8.82708 4.87 8.84995C4.60036 8.86561 4.34047 8.95604 4.11962 9.11105C3.89876 9.26606 3.72572 9.47949 3.62 9.72728C3.20921 10.7792 2.99894 11.8984 3 13.0273C3 15.407 3.94822 17.6892 5.63604 19.3719C7.32387 21.0547 9.61306 22 12 22C14.387 22 16.6761 21.0547 18.364 19.3719C20.0518 17.6892 21 15.407 21 13.0273L21 12.9874Z"
        fill="#fc3c17"
      />
    </svg>
  );
};

export default OrgasmSolid;
